import React from 'react';

export default function User() {
  return <div>User</div>;
}
